export default "__VITE_ASSET__Ds2Dk$2c__"